import moment from 'moment';

const dueDateColourConfig = {
  complete: 'success.main',
  dueToday: 'info.main',
  overdue: 'error.main',
  dueFuture: 'grey.500',
};

const getDueDateColour = (isComplete, dueDateMoment) => {
  if (isComplete) {
    return dueDateColourConfig.complete;
  }

  if (dueDateMoment.isBefore(moment())) {
    return dueDateColourConfig.overdue;
  }

  if (dueDateMoment.isBefore(moment().endOf('day'))) {
    return dueDateColourConfig.dueToday;
  } else {
    return dueDateColourConfig.dueFuture;
  }
};


export default getDueDateColour;
